
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TEmployeeName, TEmployeeLastName } from "@/models/employee-name";
import { SMUser } from "@/store";
import ComplianceProfile from "@/modules/Compliance/Profile/ComplianceProfile.vue";
// import DetailsSummaryPage from "@/components/DetailsSummaryPage/DetailsSummaryPage.vue";

const TYPE_COMPLIANCE_PROFILE = "complianceProfile";

const MESSAGES = {
  buttonLabel: "View other",
  expiredWidget: {
    description: "The company’s Compliance subscription has expired.",
  },
};

@Component({
  components: {
    // DetailsSummaryPage,
    ComplianceProfile,
    DetailsSummaryContainer: () =>
      import("@/components/DetailsSummaryPage/components/DetailsSummaryContainer.vue"),
    ComplianceExpiredWidget: () => import("@/modules/Compliance/ComplianceExpiredWidget.vue"),
  },
})
export default class EmployeeProfilePersonalInfo extends Vue {
  employee: TEmployeeName = {} as TEmployeeName;

  type = TYPE_COMPLIANCE_PROFILE;

  messages = MESSAGES;

  mounted() {
    this.fetchEmployeeName();
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  async fetchEmployeeName() {
    const { data } = await this.axios.get(API_ROUTES.EMPLOYEE_NAME);

    this.employee = data;
  }

  getEmployeeName(employee: TEmployeeName | TEmployeeLastName) {
    const { title, first_name, last_name } = employee;
    let name = "";

    name += title ? `${title} ` : "";
    name += first_name ? `${first_name} ` : "";
    name += last_name ? last_name : "";

    return name;
  }

  get isLastNames() {
    return this.employee.last_names?.length;
  }
}
